<div class="detail-page-card">
    <div class="detail-page-card-title">
        <span>Execution working method</span>
    </div>
    <div class="detail-page-card-body padded">
        @if (selectedStepExecutionDetails) {
            @for (item of selectedStepExecutionDetails | keyvalue; track item) {
                <div class="form-group col cerrix-textfield">
                    <label>{{ item.key }}</label>
                    <textarea
                        autogrow
                        class="form-control form-control-sm"
                        readonly
                        [value]="item.value"
                    >
                    </textarea>
                </div>
            }
        } @else {
            <span>No execution working method defined for this step.</span>
        }
    </div>
</div>
